/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import { Drawer } from "antd";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "../../../../Common/Svgs/CloseIcon";
import ArrowIcon from "../../../../Common/Svgs/ArrowIcon";
import TimeoffCard from "./Calendar/Common/TimeoffCard";
import { client } from "../../../../Utils/axiosClient";
import { updateUsers } from "../../../../Redux/Slices/users.slice";
import ReassignTimeoffModal from "./Calendar/ReassignTimeoffModal";

const DriverRequestDrawer = ({ visible, onCancel }) => {
  const dispatch = useDispatch();

  const [timeoffs, setTimeoffs] = useState([]);

  const { driverDetailDrawer } = useSelector((state) => state.users);
  const driverId = driverDetailDrawer?.data?.id;

  const { transferTimeoffModal } = useSelector((state) => state.users);

  const fetchTimeoffs = async () => {
    try {
      const res = await client.get(
        `${process.env.REACT_APP_API_URL}/drivers/all-time-off`,
        { params: { driverId } },
      );

      const formatted = res?.data?.timeoffs?.map((item) => ({
        id: item.id,
        startDate: item.startDate,
        endDate: item.endDate,
        appliedOn: item.createdAt,
        updatedAt: item.updatedAt,
        notes: item.notes,
        status: item.status,
        name: item.name,
        tripsCount: Number(item.tripsCount),
        sessionsCount: Number(item.sessionsCount),
        updatedBy: item.name,
      }));

      setTimeoffs(formatted);
    } catch (err) {
      console.log("Error fetching timeoffs:", err);
    }
  };

  useEffect(() => {
    if (visible && driverId) {
      fetchTimeoffs();
    }
  }, [visible, driverId]);

  const handleApprove = async (item) => {
    const trips = item.tripsCount || 0;
    const sessions = item.sessionsCount || 0;

    const hasConflict = trips > 0 || sessions > 0;

    if (hasConflict) {
      dispatch(
        updateUsers({
          key: "transferTimeoffModal",
          value: {
            visible: true,
            timeoffId: item.id,
            driverId,
            trips,
            sessions,
          },
        }),
      );

      return;
    }

    try {
      await client.put(
        `${process.env.REACT_APP_API_URL}/drivers/approve-timeoff`,
        {
          id: item.id,
        },
      );

      await fetchTimeoffs();
    } catch (e) {
      console.log("Error approving:", e);
    }
  };

  const handleReject = async (timeoffId) => {
    try {
      await client.put(
        `${process.env.REACT_APP_API_URL}/drivers/reject-timeoff`,
        {
          id: timeoffId,
        },
      );
      await fetchTimeoffs();
    } catch (e) {
      console.log("Error rejecting timeoff: ", e);
    }
  };

  return (
    <Drawer
      width={560}
      placement="right"
      closable={false}
      zIndex={2000}
      maskStyle={{
        background: "transparent",
      }}
      open={visible}
      className="rounded-tl-xl"
      onClose={onCancel}
    >
      <div className="bg-background-white h-full overflow-y-auto">
        <div className="flex items-center justify-between p-6 border-b border-light-grey">
          <div className="flex items-center gap-x-2">
            <div role="button" className="-rotate-90" onClick={onCancel}>
              <ArrowIcon size={20} className="text-dark-gray" />
            </div>

            <p className="font-poppins font-medium text-base">
              Time-off Requests
            </p>
          </div>

          <CloseIcon className="w-5 h-5 cursor-pointer stroke-dark-grey-text" />
        </div>

        <div className="py-4 px-6">
          {timeoffs.map((item, index) => (
            <div key={item.id} className="mt-4 space-y-4">
              <TimeoffCard
                tripsCount={item?.tripsCount}
                sessionsCount={item?.sessionsCount}
                item={item}
                handleReject={handleReject}
                handleApprove={handleApprove}
                hideName
              />

              {index + 1 !== timeoffs.length && (
                <div className="w-full h-px bg-light-grey mb-4" />
              )}
            </div>
          ))}
        </div>
      </div>
      <ReassignTimeoffModal
        visible={transferTimeoffModal?.visible}
        onCancel={async () => {
          dispatch(
            updateUsers({
              key: "transferTimeoffModal",
              value: { visible: false, data: {} },
            }),
          );
          await fetchTimeoffs();
        }}
      />
    </Drawer>
  );
};

export default DriverRequestDrawer;
